import React from 'react';
import { IProps as IBlockProps } from './ErrorBlock.interface';
import { ErrorBlock } from './ErrorBlock.component';
import TranslationComponent from '@/utils/TranslationComponent/TranslationComponent';
import * as translation from '@/utils/TranslationComponent/translation.utilities';

export interface IBlockInputProps {
  heading?: string;
  content?: string;
  buttons?: any[]; // Array of button props
  [key: string]: any; // Allow passthrough of other props, including BlockWrapper props
}

const mapInputToProps = (input: IBlockInputProps): IBlockProps => {
  const { heading, content, buttons, ...rest } = input;

  return {
    heading: heading,
    content: content,
    buttons: buttons
      ? buttons.map((button) => translation.mapAnchorProps(button))
      : undefined,
    ...rest, // Pass through BlockWrapper related settings
  };
};

const WysiwygBlockTranslation: React.FC<IBlockInputProps> = (inputProps) => (
  <TranslationComponent
    inputProps={inputProps}
    TargetComponent={ErrorBlock}
    mapProps={mapInputToProps}
  />
);

export default WysiwygBlockTranslation;
